<h2 mat-dialog-title>RSVP for {{ data.event?.eventName || "Event" }}</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    @if (locations.length > 0) {
      <section class="location-selection">
        <h4>Select Location</h4>
        <mat-radio-group
          color="primary"
          formControlName="location"
          aria-label="Select a location"
        >
          @for (loc of locations; track loc) {
            <mat-radio-button [value]="loc" class="location-option">
              {{ loc }}
            </mat-radio-button>
          }
        </mat-radio-group>
        @if (
          form.get("location")?.hasError("required") &&
          form.get("location")?.touched
        ) {
          <mat-error> Please select a location </mat-error>
        }
      </section>
    }

    @if (allowDietaryRequirements) {
      <mat-form-field appearance="outline">
        <mat-label>Dietary Requirements</mat-label>
        <mat-select formControlName="dietary">
          @for (req of dietaryOptions; track req) {
            <mat-option [value]="req">
              {{ req }}
            </mat-option>
          }
        </mat-select>
        @if (
          form.get("dietary")?.hasError("required") &&
          form.get("dietary")?.touched
        ) {
          <mat-error> Please select a dietary requirement </mat-error>
        }
      </mat-form-field>
    }

    @if (allowDietaryRequirements) {
      <mat-form-field appearance="outline">
        <mat-label>Allergies (please specify)</mat-label>
        <input
          matInput
          formControlName="allergies"
          placeholder="e.g. peanuts, shellfish"
        />
      </mat-form-field>
    }

    @if (allowNotes) {
      <mat-form-field appearance="outline">
        <mat-label>Notes</mat-label>
        <textarea
          matInput
          formControlName="notes"
          placeholder="Any additional notes or special requests..."
          rows="3"
        ></textarea>
      </mat-form-field>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions-row">
  <button mat-flat-button color="accent" (click)="close()">Close</button>
  <span class="actions-right">
    <button mat-flat-button color="accent" (click)="decline()">Decline</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="form.invalid"
      (click)="accept()"
    >
      Accept
    </button>
  </span>
</mat-dialog-actions>
